import { useContext } from "react"
import { BasketContext } from "../contexts/BasketContexts"
import '../styles/modal.css'

export const MovieModal = ({movie}) =>
{
    const {setBasket} = useContext(BasketContext);

    const color = {color: "gray"};
    const background = {background: "none"}

    const onAdd = () =>
    {
        setBasket((basket) =>
        {
            return [...basket, movie];
        })
    }

    return <div className="modal fade" id="movieModal">
        <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="container-fluid">
                        <div className="row justify-content-sm-center">
                            <div className="col-md-auto">
                                {movie.poster && <img src={movie.poster}/>}
                            </div>
                        </div>  
                    </div>
                </div>
                <div className="modal-body">
                    {movie.plot && <p>{movie.plot}</p>}
                </div>
                <div className="modal-footer">
                    {movie.price && <span>£{movie.price}</span>}
                    {movie.stock
                        ? <button className="btns" onClick={onAdd}>Add to basket</button>
                        : <button className="btns" id="disabled" disabled style={{...color, ...background}}>Out of stock</button>}
                </div>
            </div>
        </div>
    </div>
}